import React, { FunctionComponent } from 'react'

export interface Props {
  color?: string
  width?: string
  height?: string
  className?: string
}

export const HomeIcon: FunctionComponent<Props> = ({
  color = '#01c0a0',
  width = '18px',
  height = '18px',
  className,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
    <polyline points="9 22 9 12 15 12 15 22" />
  </svg>
)

export default HomeIcon
